export const getMessagesFromClient = ({ messages }) => messages.all;



// WEBPACK FOOTER //
// ./src/redux/messages/selectors.js